import { gql } from "@apollo/client";

export const GET_POPUP_NOTIFICATIONS = gql`
    query GetPopupNotifications {
        popupNotifications {
            popupNotifications {
                id
                title
                content
                isRead
                createdAt
                updatedAt
            }
            unreadCount
        }
    }
`;

export const UPDATE_POPUP_NOTIFICATION = gql`
    mutation UpdatePopupNotification($id: ID!) {
        updatePopupNotification(id: $id) {
            status
            id
        }
    }
`;
